export default "__VITE_ASSET__g0vMZMAC__"